import { render } from "./DropdownTableAction.vue?vue&type=template&id=360caec4&scoped=true"
import script from "./DropdownTableAction.vue?vue&type=script&lang=js"
export * from "./DropdownTableAction.vue?vue&type=script&lang=js"

import "./DropdownTableAction.vue?vue&type=style&index=0&id=360caec4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-360caec4"]])

export default __exports__